export interface GetWLOrgConfigUrlParams {
  isMobile: boolean;
  isTestEnvironment: boolean;
  /**
   * Typed as a string on EnvConfig, but several envs omit it entirely
   * (gcash/whitelabel test envs, and whitelabel-mobile local.staging which proxies everything).
   */
  baseUrl: string | undefined;
  /** `null` when the override search param is absent, `undefined` where overrides are not allowed. */
  override: string | null | undefined;
  hostname: string;
}

/**
 * Capacitor serves from a local bundle, so a relative /config/* 404s on real mobile builds. Those
 * fetch the config from VITE_BASE_URL instead, but only when it is set — envs without it must keep
 * the relative URL so the local dev proxy can serve it, and so a missing value cannot throw before
 * the provider finishes loading. Cypress mobile sets VITE_IS_TEST_ENVIRONMENT to keep relative URLs
 * plus the DEFAULT config fallback.
 */
export function getWLOrgConfigUrl({
  isMobile,
  isTestEnvironment,
  baseUrl,
  override,
  hostname,
}: GetWLOrgConfigUrlParams): string {
  if (isMobile && !isTestEnvironment && baseUrl) {
    const normalizedBaseUrl = baseUrl.replace(/\/$/, '');
    const host = normalizedBaseUrl.replace(/^https?:\/\//, '');
    return `${normalizedBaseUrl}/config/${host}.json`;
  }
  return `/config/${override ?? hostname}.json`;
}
